import { useState, useEffect } from 'react'
import { getEmployeeSecretaryAPI } from '../services/employee'

function UseSecretary(orgId) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const body = {
        orgId
      }
      const resp = await getEmployeeSecretaryAPI(body)
      if (!resp) return
      if (resp.status) {
        setData(
          resp.result.map((d) => {
            return { label: d.username, value: d.code }
          })
        )
      } else {
        setData([])
      }
    }
    if (orgId) {
      getData()
    }
  }, [orgId])

  return data
}

export default UseSecretary
